<template>
	<div class="ho-wrap-content" @scroll="scroll">
		<Logo v-bind:scrollTop="scrollTop" />
		<Description />
		<!-- <Slideshow /> -->
		<a id="Overview"></a>
		<h2>
			{{ $t('hoTitle') }} <br />
			{{ $t('hoText') }}
		</h2>
		<SystemOverview />
		<SystemDetails />
		<MoreInformation />
	</div>
</template>

<script>
import Logo from '../components/Logo';
import Description from '../components/Description';
import SystemOverview from '../components/SystemOverview';
import SystemDetails from '../components/SystemDetails.vue';
import MoreInformation from '../components/MoreInformation.vue';

export default {
	name: 'Home',
	components: {
		Logo,
		Description,
		SystemOverview,
		SystemDetails,
		MoreInformation,
	},
	data() {
		return {
			scrollTop: 0,
		};
	},
	created() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	},
	methods: {
		scroll(e) {
			this.scrollTop = e.target.scrollTop;
		},
	},
};
</script>

<style scoped>
.ho-wrap-content {
	width: 100%;
	height: fit-content;
	/* height: 90%; */
	text-align: center;
	/* background-color: var(--main-color-light); */
	overflow: auto;
	overflow-x: hidden;
	/* position: relative; */
	/* padding: 10px; */
}

h2 {
	font-size: 30px;
	color: var(--main-color-highlight);
	font-weight: normal;
	border-bottom: 1px solid var(--main-color-text-light);
	width: fit-content;
	margin: auto;
	padding: 10px 15px 5px 15px;
}

@media (pointer: none), (pointer: coarse) {
	h2 {
		font-size: 20px;
	}
}
</style>
